<template>
  <div class="container">
    <head-nav-bar title="体检自助" :fixed="true" />
    <div class="mt-header-nav" style="paddingTop:1px">
      <div v-if="loading" class="loading-wraper">
        <van-loading color="#1989fa" />
      </div>
      <div v-else>
        <div class="card-button-list">
          <router-link
            v-if="SettingList.enabledMobileOurHospitalNucleinCheck"
            tag="div"
            class="card-button-item"
            to="/nuclein/check?ourHospital=1"
          >
            <div class="action-icon">
              <i
                class="iconfont iconyonghuziliaogerenxinxigerenziliao-xianxing"
              />
            </div>
            <div class="action-text">
              本院员工核酸检测
            </div>
          </router-link>
        </div>
        <van-empty
          v-if="!SettingList.enabledMobileOurHospitalNucleinCheck"
          description="暂无项目"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Empty, Loading } from "vant";
export default {
  components: {
    [Empty.name]: Empty,
    [Loading.name]: Loading,
  },
  data() {
    return {
      SettingList: {},
      loading: false,
    };
  },
  created() {
    this.loading = true;
    this.$post("GetWxSystemParameterInfo", {})
      .then(res => {
        this.SettingList = res.data;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>

<style lang="less" scoped>
.card-button-list {
  padding: 10px;
  .card-button-item {
    padding: 10px;
    display: flex;
    background: @main-color;
    color: #fff;
    border-radius: 5px;
    .action-icon {
      .iconfont {
        font-size: 30px;
      }
    }
    .action-text {
      flex: 1;
      font-size: 16px;
      line-height: 42px;
      padding-left: 10px;
    }
  }
}
.loading-wraper {
  text-align: center;
  padding-top: 50px;
}
</style>
